module.exports = __webpack_public_path__ + "img/sh_my.9e2bf58b.png";